define(function() {
  const IpsModel = require('civicsBase/ipsModel');
  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portlet/configuration?portletName={0}',
    url:function(){
      return this.urlRoot.format(this.portletId);
    }
  });
})
